import moment from "moment";
document.addEventListener('DOMContentLoaded', function () {
  const sickCalc = document.getElementById('sick-calculation');
  if (sickCalc) {
    document.addEventListener('change', function(event) {
      // Обработка изменений в категории и опыте
      if (event.target.matches('select[name=category], select[name=experience]')) {
        const categorySelect = document.querySelector('select[name=category]');
        const experienceSelect = document.querySelector('select[name=experience]');

        if (categorySelect.value > 0) {
          document.querySelector(".percentage").textContent = '100%';
        } else {
          document.querySelector(".percentage").textContent = experienceSelect.value;
        }
      }
    });

    document.getElementById('sick-calculation').addEventListener('change', function(event) {
      if (event.target.matches('select[name=period], .tariff_rate, input.vocation, input.sick-live.from, input.work_from')) {
        const period = Number(document.querySelector('select[name=period]').value);
        const workFromValue = document.querySelector('input.work_from').value;
        const vocationValue = document.querySelector('.vocation').value || 0;

        const tempDays = parseInt(calculateDays(workFromValue, period));
        const factDaysNum = document.querySelector('.fact_days_num');
        factDaysNum.textContent = tempDays - parseInt(vocationValue);

        let deysSum = Number(factDaysNum.textContent);

        if (deysSum == 0) {
          const dateMode = dateTransform(document.querySelector('input.sick-live').value);
          const a = moment(dateMode);
          const b = moment(dateMode);
          const bMod = b.subtract(1, 'y');
          factDaysNum.textContent = a.diff(bMod, 'days');
        }

        if (period == 0 || deysSum == 0) {
          const tariffRate = document.querySelector('.tariff_rate');
          const tariffRateVal = tariffRate.value;
          const tariffRateValPrepare = tariffRateVal.toString().replace(/,/, ".");
          const parsedTariff = parseFloat(tariffRateValPrepare);
          const sumSalary = document.querySelector('.sum_salary');

          if (!Number.isNaN(parsedTariff)) {
            sumSalary.value = (parsedTariff * 12).toFixed(2);
            const placeholder = sumSalary.closest('div').querySelector('.placeholder');
            if (placeholder) {
              placeholder.classList.add('small');
            }
          } else {
            sumSalary.value = '';
            const placeholder = sumSalary.closest('div').querySelector('.placeholder');
            if (placeholder) {
              placeholder.classList.remove('small');
            }
          }
        }
      }
    });

    function checkDate() {
      if (document.querySelector('input.work_from')) {
        const start = moment(dateTransform(document.querySelector('input.work_from').value));
        const sickFrom = moment(dateTransform(document.querySelector('input.sick-live.from').value));

        return sickFrom.diff(start, 'month') > 12;
      } else {
        return false;
      }
    }

    function dateTransform(date) {
      const dateArray = date.split('.');
      return (dateArray[1] + '/' + dateArray[0] + '/' + dateArray[2]).toString();
    }

    function calculateDays(date, month) {
      if (month != 12) {
        let dateMode = dateTransform(date);

        if (month > 1) {
          const dateFirst = new Date(dateMode),
              y = parseInt(dateFirst.getFullYear()),
              m = parseInt(dateFirst.getMonth()),
              fd = parseInt(dateFirst.getDate());

          if (fd > 1) {
            dateMode = new Date(y, m + 1, 1);
          } else {
            dateMode = new Date(y, m, 1);
          }
        }

        dateMode = moment(dateMode);
        if (month > 1) {
          dateMode = dateMode.subtract(1, 'd');
        }

        let secondDay = dateTransform(document.querySelector('input.sick-live.from').value);
        if (month > 1) {
          const dateSecond = new Date(secondDay),
              y2 = parseInt(dateSecond.getFullYear()),
              m2 = parseInt(dateSecond.getMonth());
          secondDay = new Date(y2, m2, 0);
        }
        secondDay = moment(secondDay);

        const workFrom = moment(dateTransform(document.querySelector('input.work_from').value));

        if (month == 12) {
          if (checkDate()) {
            const a = moment(dateMode);
            const b = moment(dateMode);
            const bMod = b.subtract(1, 'y');
            return a.diff(bMod, 'days');
          } else {
            // Здесь была логика выбора радиокнопок, адаптируем для селекта
            const periodSelect = document.querySelector("select[name='period']");
            periodSelect.value = "5"; // Выбираем значение 5 (вместо клика на радиокнопку)

            // Триггер события изменения для селекта с choices.js
            const changeEvent = new Event('change', { bubbles: true });
            periodSelect.dispatchEvent(changeEvent);

            // Обновление UI для choices, если необходимо (зависит от реализации)
            if (window.choicesInstances && window.choicesInstances[periodSelect.id]) {
              window.choicesInstances[periodSelect.id].setChoiceByValue("5");
            }

            return calculateDays(date, 5);
          }
        } else if (month == 5) {
          secondDay = moment(secondDay);
          return secondDay.diff(moment(dateMode), 'days');
        } else if (month == 1) {
          secondDay = moment(secondDay);
          return secondDay.diff(dateMode, 'days');
        } else if (month == 0) {
          const a = moment();
          const b = a.clone();
          b.subtract(1, 'y');
          return a.diff(b, 'days');
        }
      } else {
        const dateMode = dateTransform(document.querySelector('input.sick-live').value);
        const dateFirst = new Date(dateMode),
            y = parseInt(dateFirst.getFullYear()),
            m = parseInt(dateFirst.getMonth()),
            fd = parseInt(dateFirst.getDate());

        const newDateMode = new Date(y, m, 1);

        if (checkDate()) {
          const a = moment(newDateMode).subtract(1, 'd');
          const b = moment(newDateMode).subtract(1, 'd');
          const bMod = b.subtract(1, 'y');
          return a.diff(bMod, 'days');
        } else {
          // Здесь была логика выбора радиокнопок, адаптируем для селекта
          const periodSelect = document.querySelector("select[name='period']");
          periodSelect.value = "5"; // Выбираем значение 5 (вместо клика на радиокнопку)

          // Триггер события изменения для селекта с choices.js
          const changeEvent = new Event('change', { bubbles: true });
          periodSelect.dispatchEvent(changeEvent);

          // Обновление UI для choices, если необходимо
          if (window.choicesInstances && window.choicesInstances[periodSelect.id]) {
            window.choicesInstances[periodSelect.id].setChoiceByValue("5");
          }

          return calculateDays(date, 5);
        }
      }
    }

    function calculateSickDays() {
      const fromDay = moment(dateTransform(document.querySelector('input.sick-live.from').value));
      const toDay = moment(dateTransform(document.querySelector('input.sick-live.to').value));
      return toDay.diff(fromDay, 'days') + 1;
    }

    function calculateSickLeave(minZP, esvRate) {
      const sumSalary = Number((document.querySelector('.sum_salary').value || 0).toString().replace(/,/, "."));
      const factDaysNum = Number(document.querySelector('.fact_days_num').textContent);
      const percentage = Number(document.querySelector('.percentage').textContent.replace(/\D+/g, "")) / 100;
      const sumSickLive = Number((document.querySelector('.sum_sick_live').value || 0).toString().replace(/,/, "."));

      const avgSalary = parseFloat(((sumSalary - sumSickLive) / factDaysNum * percentage).toFixed(2));
      const countSickLeave = calculateSickDays();

      let avgSalaryRes;
      const averageMonthDaysCount = 30.44;
      const minZPToDay = parseFloat((minZP / averageMonthDaysCount).toFixed(2));
      const fifteenMinZPToDay = parseFloat(((minZP * esvRate) / averageMonthDaysCount).toFixed(2));

      const experienceValue = Number(document.querySelector('select[name=experience-2]').value.replace(/,/, "."));

      if (experienceValue < 6) {
        if (avgSalary >= minZPToDay) {
          avgSalaryRes = minZPToDay;
        } else if (avgSalary < minZPToDay) {
          avgSalaryRes = avgSalary;
        }
      } else {
        if (avgSalary <= fifteenMinZPToDay) {
          avgSalaryRes = avgSalary;
        } else if (avgSalary > fifteenMinZPToDay) {
          avgSalaryRes = fifteenMinZPToDay;
        }
      }

      document.querySelector('.avg_salary').textContent = avgSalaryRes.toFixed(2);
      document.querySelector('.count_sick_leave').textContent = countSickLeave.toFixed(2);
      document.querySelector('.total_payment').textContent = (avgSalaryRes * countSickLeave).toFixed(2);

      if (countSickLeave <= 5) {
        document.querySelector('.enterprise_payment').textContent = (avgSalaryRes * countSickLeave).toFixed(2);
        document.querySelector('.fund_payment').textContent = '0';
      } else {
        document.querySelector('.enterprise_payment').textContent = (avgSalaryRes * 5).toFixed(2);
        document.querySelector('.fund_payment').textContent = (avgSalaryRes * (countSickLeave - 5)).toFixed(2);
      }
    }

    const submitBtn = document.querySelector('.calculate_result');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        const date = document.querySelector('input.sick-live.from').value;
        fetch('/nsl-calculator/get-min-salary?date_from=' + date + '&date_to=' + date)
            .then(response => response.json())
            .then(res => {
              calculateSickLeave(res[0].min_salary, res[0].esv_rate);
            })
            .catch(error => {
              console.error('Ошибка при получении данных:', error);
            });
      });
    }
  }

});
